import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from './fpp_media_queries';

import constants from '@ifixit/toolbox/dist/constants/index';

const { color, fontSize, lineHeight, spacing } = constants;

const MainHeading = styled.h2({
   fontSize: fontSize[8],
   fontWeight: 900,
   textTransform: 'uppercase',
   lineHeight: lineHeight.solid,
   textAlign: 'center',
   borderBottom: 'none',
   padding: 0,
   margin: '0 auto',
   whiteSpace: 'pre-line',
   color: color.gray[9],

   [media.mobileLandscapeAll]: {
      fontSize: 60,
   },

   [media.mobile]: {
      fontSize: 34,
      lineHeight: 1.2,
   },
});

const SubHeading = styled.h2({
   fontSize: fontSize[4],
   fontWeight: 400,
   borderBottom: 'none',
   padding: 0,
   margin: 0,
   textAlign: 'center',
   color: color.gray[9],

   [media.mobile]: {
      fontSize: fontSize[3],
   },
});

const Body = styled.p(props => ({
   fontSize: fontSize[2],
   fontWeight: 400,
   lineHeight: 2.2,
   textAlign: 'center',
   display: 'block',
   margin: '0 auto',
   paddingTop: spacing[3],
   color: color.gray[7],
   maxWidth: props.maxWidth,

   [media.mobile]: {
      fontSize: fontSize[1],
   },
}));

const TextComponent = ({ heading, subheading, body, maxWidth }) => (
   <div>
      {heading && <MainHeading>{heading}</MainHeading>}
      {subheading && <SubHeading>{subheading}</SubHeading>}
      {body && <Body maxWidth={maxWidth}>{body}</Body>}
   </div>
);

TextComponent.propTypes = {
   heading: PropTypes.string,
   subheading: PropTypes.string,
   body: PropTypes.string,
   maxWidth: PropTypes.number,
};

TextComponent.defaultProps = {
   heading: null,
   subheading: null,
   body: null,
   maxWidth: 600,
};

export default TextComponent;
